<template>
	<div class="box box-sidebar">
		<div class="header">
			<router-link :to="{ name: 'home' }" class="back"><icon file="arrow-left" :size="24" /></router-link>
			<div class="tabs">
				<div v-if="display_template" class="tab" :class="{ active: tab == 'summary' }" @click="tab = 'summary'" title="Table des matières"><icon file="list" :size="24" /></div>
				<div class="tab" :class="{ active: tab == 'documents' }" @click="tab = 'documents'" title="Pièces jointes"><icon file="paperclip" :size="24" /></div>
				<div class="tab" :class="{ active: tab == 'settings' }" @click="tab = 'settings'" title="Paramètres de l'étude"><icon file="settings" :size="24" /></div>
			</div>
		</div>
		<div class="content">
			
			<div class="sidebar-content">
				<div class="scroll-wrap">
					<div class="scroll vb-dark" v-bar>
						<div class="scroll-content">
							
							<div class="tab-content summary" v-if="display_template && tab == 'summary'">
								<p class="name">{{ active_study.nom }}</p>

								<div class="parts">
									<!-- <div class="part" @click="scroll_to_section({ slug: 'garde' })">
										<span class="part-no"></span>
										<span class="part-name">Page de garde</span>
									</div> -->
									<template v-if="active_study.segment.code == 'GIE'">
										<div class="part" @click="scroll_to_section({ slug: '1-gie-classique' })">
												<span class="part-no">1.</span>
												<span class="part-name">Analyse des forces et faiblesses du site</span>
											</div>
										<div class="part" @click="scroll_to_section({ slug: '1-gie-classique' })">
											<span class="part-no">2.</span>
											<span class="part-name">Dynamique territoriale et caractéristiques des ménages</span>
										</div>
										<div v-if="this.active_study.etudeType.nom!=='Flash'">
											<div class="part" @click="scroll_to_section({ slug: '2-gie-classique' })">
												<span class="part-no">3.</span>
												<span class="part-name">Caractéristiques et standing de la résidence</span>
											</div>
											<div class="part" @click="scroll_to_section({ slug: '2-gie-classique' })">
												<span class="part-no">4.</span>
												<span class="part-name">Dynamique du marché résidentiel</span>
											</div>
											<div class="part" @click="scroll_to_section({ slug: '3-gie-classique' })">
												<span class="part-no">5.</span>
												<span class="part-name">Capacités financières des ménages</span>
											</div>
											<div class="part" @click="scroll_to_section({ slug: '4-gie-classique' })">
												<span class="part-no">6.</span>
												<span class="part-name">Synthèse et préconisations</span>
											</div>
											<div class="part" @click="scroll_to_section({ slug: '5-gie-classique' })" :class="{disabled: !(this.active_study.etudeData.gie.sectionComplements.show_locaux_commerciaux_table || this.active_study.etudeData.gie.sectionComplements.show_bail_emphyteotique_table)}">
												<span class="part-no">7.</span>
												<span class="part-name">Compléments</span>
											</div>
										</div>
										<div v-else>
											<div class="part" @click="scroll_to_section({ slug: '2-gie-flash' })">
												<span class="part-no">3.</span>
												<span class="part-name">Caractéristiques et standing de la résidence</span>
											</div>
											<div class="part" @click="scroll_to_section({ slug: '2-gie-flash' })">
												<span class="part-no">4.</span>
												<span class="part-name">Dynamique du marché résidentiel</span>
											</div>
											<div class="part" @click="scroll_to_section({ slug: '3-gie-flash' })">
												<span class="part-no">5.</span>
												<span class="part-name">Capacités financières des ménages</span>
											</div>
											<div class="part" @click="scroll_to_section({ slug: '3-gie-flash' })">
												<span class="part-no">6.</span>
												<span class="part-name">Synthèse et préconisations</span>
											</div>
										</div>
										<div class="part" @click="scroll_to_section({ slug: 'gie-lexique' })">
											<span class="part-no"></span>
											<span class="part-name">Définitions</span>
										</div>
										<div class="part" @click="scroll_to_section({ slug: 'gie-map' })">
											<span class="part-no"></span>
											<span class="part-name">Annexe</span>
										</div>
									</template>

									<template v-else>
										<div class="part" @click="scroll_to_section({ slug: 'garde' })">
											<span class="part-no">1.</span>
											<span class="part-name">Synthèse et positionnement</span>
										</div>
										<div class="part" @click="scroll_to_section({ slug: 'grand_projet' })" v-if="active_study.etudeType.slug == 'grand_projet'">
											<span class="part-no">2.</span>
											<span class="part-name">Le projet urbain et ses conséquences sur l'attractivité à terme du programme étudié</span>
										</div>
										<div class="part" @click="scroll_to_section({ slug: 'grand_projet' })" v-if="active_study.etudeType.slug == 'grand_projet'">
											<span class="part-no">3.</span>
											<span class="part-name">Approche quantitative des besoins pour le locatif intermédiaire au sein du projet urbain</span>
										</div>
										<div class="part" @click="scroll_to_section({ slug: 'territoire' })">
											<span class="part-no" v-if="active_study.etudeType.slug == 'grand_projet'">4.</span>
											<span class="part-no" v-else>2.</span>
											<span class="part-name">Localisation du projet</span>
										</div>
										<div class="part" @click="scroll_to_section({ slug: 'territoire' })">
											<span class="part-no" v-if="active_study.etudeType.slug == 'grand_projet'">5.</span>
											<span class="part-no" v-else>3.</span>
											<span class="part-name">Dynamique territoriale</span>
										</div>

										<div class="part" @click="scroll_to_section({ slug: 'marches' })" v-if="active_study.etudeType.slug !== 'actu'">
											<span class="part-no" v-if="active_study.etudeType.slug == 'grand_projet'">6.</span>
											<span class="part-no" v-else>4.</span>
											<span class="part-name">Marché de la promotion</span>
										</div>

										<div class="part" @click="scroll_to_section({ slug: 'situation' })">
											<span class="part-no" v-if="active_study.etudeType.slug == 'grand_projet'">7.</span>
											<span class="part-no" v-else-if="active_study.etudeType.slug === 'actu'">4.</span>
											<span class="part-no" v-else>5.</span>
											<span class="part-name">Marché locatif</span>
										</div>

										<div class="part" @click="scroll_to_section({ slug: 'situation' })" v-if="active_study.etudeType.slug !== 'actu'">
											<span class="part-no" v-if="active_study.etudeType.slug == 'grand_projet'">8.</span>
											<span class="part-no" v-else>6.</span>
											<span class="part-name">Budget des ménages</span>
										</div>

										<div class="part" @click="scroll_to_section({ slug: 'lexique1' })">
											<span class="part-no"></span>
											<span class="part-name">Définitions</span>
										</div>
										<div class="part" @click="scroll_to_section({ slug: 'lexique2' })">
											<span class="part-no"></span>
											<span class="part-name">Annexe</span>
										</div>
									</template>
								

									<!-- <div v-for="(section, index) in active_study.template.sections" :key="index" class="part" @click="scroll_to_section(section)">
										<span class="part-no">{{ index + 1}}.</span>
										<span class="part-name">{{ section.nom }}</span>
									</div> -->
								</div>
							</div>
							
							<div class="tab-content documents" v-if="tab == 'documents'">
								<p class="name">Pièces jointes</p>
				
								<upload-file v-if="tab == 'documents'" />

								<documents :cols="1" />
							</div>
							
							<div class="tab-content settings" v-if="tab == 'settings'">
								<p class="name">Paramètres de l'étude</p>
								
								<form-study :cols="1" mode="edition" :readonly="readonly" />
							</div>

						</div>
					</div>
				</div>

			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import FormStudy from "@/components/study/sidebar/form-study";
import Documents from "@/components/study/sidebar/documents";
import UploadFile from "@/components/study/sidebar/upload-file";

export default {
	name: "sidebar",
	data: function () {
		return {
			tab: "summary"
		};
	},
	props: {
		"readonly": { default: false },
	},
	computed: {
		...mapGetters([ "active_study", "display_template" ]),
	},
	methods: {
		scroll_to_section: function (section) {
			this.$store.dispatch("scroll_to_section", { section: section });
		}
	},
	components: { FormStudy, Documents, UploadFile },
	mounted () {
		if (!this.display_template) {
			this.tab = "settings";
		}
	},
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/app'

.box.box-sidebar
	height calc(100% - 80px)
	.header
		padding-left 64px
		.back
			position absolute
			left 28px
			top 28px
			.icon
				display block
		.button-param
			position absolute
			right 28px
			top 28px
			cursor pointer
			opacity 0.5
			&:hover
				opacity 1
			.icon
				display block

.sidebar-content
	height calc(100% - (64px + 32px))
	height 100%


.tab-content
	&.settings
		.form.form-study
			padding 8px 24px 24px 24px
	
	.name
		display block
		padding 24px
		font-weight 500
		border-bottom 2px solid #eee
		margin 0 0 16px 0
	.parts
		.part
			display block
			width 100%
			padding 8px 24px
			cursor pointer
			color lighten(dark, 25%)
			line-height 24px
			&.disabled
				opacity 0.5
			&:hover
				background-color alpha(dark, 5%)
				color dark
			.part-no
				position absolute
				left 24px
				top 8px
				width 24px
			.part-name
				display block
				margin-left 24px

.sidebar-footer
	display none
	height (64px + 32px)
	padding 16px
	text-align center
	// box-shadow 0 -1px 0 0px #ddd
	display flex
	align-items center
	jusitfy-content center
	.last-save
		position absolute
		left 16px
		top 0px
		height 16px
		line-height @height
		font-size 10px
		color #999
		font-weight 500
		cursor default
	.button
		display inline-block
		height 64px
		background-color green
		background-color darken(green, 10%)
		cursor pointer
		border-radius radius
		color #fff
		font-weight 500
		font-size 18px
		text-shadow 1px 1px alpha(#000, 10%)
		line-height @height
		text-align center
		text-transform uppercase
		&:hover
			background-color darken(green, 20%)
		&:active
			background-color darken(green, 30%)
			transform translateY(1px)
		&.save
			width calc(100% - (64px + 16px))
			margin-right 16px
		&.print
			width 64px
		&.disabled
			background-color #ccc
			cursor not-allowed
			&:hover
				background-color #ccc
			&:active
				background-color #ccc
				transform none
		
</style>